<template>
  <div>
    <PageAppBar>Investments</PageAppBar>
    <div v-if="!message" class="page-content header-clear-small">
      <div v-if="!Object.keys(investments).length">
        <mushonga></mushonga>
      </div>
      <div v-else-if="!investments.data.data.length">
        No investment projects registered so far.
      </div>
      <div v-else v-for="investment in investments.data.data" :key="(investment.id)">
        <div>
          <div class="card card-style mb-3">
            <div class="d-flex">
              <div class="pl-3 ml-2 align-self-center">
                <h1 class="pt-4">{{ investment.project }}</h1>
                <p class="font-11 opacity-50 mt-n2 mb-2">Description: {{ investment.details }}</p>
                <p class="font-11 opacity-50 mt-n2 mb-2">Payment Interval: {{ investment.contribution_interval }}</p>
                <p class="font-11 opacity-50 mt-n2 mb-2">Duration: {{ investment.number_of_contributions }} {{ investment.contribution_interval }}s</p>
                <p @click="joinStandProject(investment)" class="font-11 opacity-50 mt-n2 mb-4">Join scheme</p>
                <router-link :to="'/investment/'+investment.id"  class="font-11 opacity-50 mt-n2 mb-4">More Details</router-link>
              </div>
              <div class="ml-auto mr-4 align-self-center">
                <i @click="joinStandProject(investment)" class="fa fa-plus-circle color-blue2-dark fa-3x mt-4 mb-4"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterBar> </FooterBar>
    </div>
    <div v-else-if="message.length" class="page-content header-clear-small">
      <div v-if="message.length">
        {{message}}
      </div>
      <div class="card card-style">
        <div class="content">
          <h1>TBD INVESTMENTS</h1>
          <p class="color-highlight font-12 mt-n3 pt-1 mb-2">You have joined TIP{{investment.id}}</p>
          <p v-if="Object.keys(investment).length">To begin you have to start making your contributions of ${{investment.contribution_amount}}
            starting {{investment.start_date}} for {{investment.number_of_contributions}} {{investment.contribution_interval}}s </p>
        </div>
      </div>
      <FooterBar> </FooterBar>
    </div>
  </div>
</template>

<script>
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
import global from "@/mixins/global";
import axios from "axios";
export default {
  name: "Investment",
  components: {PageAppBar, FooterBar},
  data(){
    return {
      investments: [],
      investment: {}
    }
  },
  mixins: [global],
  mounted() {
    axios.get(this.base_url+"investments", this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{this.investments = response}).catch(error=>{this.error = error})
  },

  methods: {
    joinStandProject(investment){
      this.investment = investment
      axios.post(this.base_url+"investments/join/"+investment.id,{},
          this.requestAuthHeaderToken(localStorage.getItem("token")
          )).then(response=>{
        this.message = response.data.message
        // this.$router.push("/stand/"+stand.id)
      }).catch(error=>{
        this.error = error
      })
    }
  },
}
</script>

<style scoped>

</style>